import { render, staticRenderFns } from "./DigitalRecordManagementList.vue?vue&type=template&id=d7ae99a0&scoped=true"
import script from "./DigitalRecordManagementList.vue?vue&type=script&lang=js"
export * from "./DigitalRecordManagementList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7ae99a0",
  null
  
)

export default component.exports